var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcTartDelete = function SvgIcTartDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#clip0_2473_3359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.552 6.32h-3.6c-.152-.368-.424-1.032-.648-1.592-.344-.864-.92-1.752-2.52-1.752h-3.68c-1.6 0-2.168.888-2.52 1.752-.224.56-.496 1.224-.648 1.592H3.448a.705.705 0 0 0 0 1.408h1.48v10.184a3.05 3.05 0 0 0 3.048 3.048h7.936a3.05 3.05 0 0 0 3.048-3.048V7.72h1.584a.705.705 0 0 0 .704-.704.69.69 0 0 0-.696-.696M8.888 5.248c.248-.608.432-.88 1.216-.88h3.68c.784 0 .976.264 1.216.88.144.352.304.736.44 1.072H8.448c.136-.336.296-.72.44-1.072m8.68 12.664a1.65 1.65 0 0 1-1.648 1.648H7.976a1.65 1.65 0 0 1-1.648-1.648V7.72h11.24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.904 17.28a.66.66 0 0 0 .664-.664v-5.864a.66.66 0 0 0-.664-.664.66.66 0 0 0-.664.664v5.864c0 .36.296.664.664.664M15.096 17.28a.66.66 0 0 0 .664-.664v-5.864a.66.66 0 0 0-.664-.664.66.66 0 0 0-.664.664v5.864c0 .36.296.664.664.664M12 17.28a.66.66 0 0 0 .664-.664v-5.864a.66.66 0 0 0-.664-.664.66.66 0 0 0-.664.664v5.864c0 .36.296.664.664.664"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2473_3359"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIcTartDelete;